export default [
    {
        id: '@payment',
        path: '/',
        onload: function () { return import('./certification'); }
    }
];
